import { NgModule } from '@angular/core';
import { RouterModule, Route } from '@angular/router';
import { PendingChangesGuard } from '../core/service/pending-changes.service';
import { DashboardComponent } from '../dashboard/component/dashboard/dashboard.component';
import { CompanyMortgageFormComponent } from './component/company-mortgage-form/company-mortgage-form.component';
import { CompanyMortgageManagerComponent } from './component/company-mortgage-manager/company-mortgage-manager.component';
import { CreditInstituteFormComponent } from './component/credit-institute-form/credit-institute-form.component';
import { CreditInstituteManagerComponent } from './component/credit-institute-manager/credit-institute-manager.component';
import { MortgageGuard } from './service/guard/mortgage-guard.service';

const routes: Route[] = [
  {
    canActivateChild: [MortgageGuard],
    path: 'company-mortgage',
    children: [
      {
        path: 'add',
        component: CompanyMortgageFormComponent,
        canDeactivate: [PendingChangesGuard],
        data: { header: 'MORTGAGE.COMPANY_MORTGAGE_CREATE' },
      },
      {
        path: 'edit/:id',
        canDeactivate: [PendingChangesGuard],
        component: CompanyMortgageFormComponent,
        data: { header: 'MORTGAGE.COMPANY_MORTGAGE_EDIT' },
      },
      { path: '', component: CompanyMortgageManagerComponent },
    ],
  },
  {
    canActivate: [MortgageGuard],
    path: 'credit-institute',
    children: [
      {
        path: 'add',
        component: CreditInstituteFormComponent,
        canDeactivate: [PendingChangesGuard],
        data: { header: 'MORTGAGE.CREDIT_INSTITUTE_CREATE' },
      },
      {
        path: 'edit/:id',
        canDeactivate: [PendingChangesGuard],
        component: CreditInstituteFormComponent,
        data: { header: 'MORTGAGE.CREDIT_INSTITUTE_EDIT' },
      },
      { path: '', component: CreditInstituteManagerComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MortgageRoutingModule {}
